import {
  ENTRY_FEE_S5,
  FIRST_PLACE_PRIZE_OPEN_QUALIFIER_S5,
  INITIAL_PURSE_S5,
  PRIZE_RATIO_OPEN_QUALIFIER_S5,
  PRIZE_TIERS_OPEN_QUALIFIER_S5,
  SIDE_GAMES_OPEN_QUALIFIER_S5,
} from "../../constants";

/**
 * Reserve $30,000 for the winner and $17,000 for side games (no Social
 * Media; it was $20,000 with it). The curve
 * starts at rank 2, with each position one less than the overall rank.
 * Combine the geometric curve with six 5% prize tiers and round to dollars.
 * Second place receives the remaining pool after all later prizes.
 * This pays the winner plus max(1, floor(30% of entrants)).
 * Below 14 entrants, second place exceeds the fixed winner prize.
 * Returns one entry per player, including zeroes for unpaid places.
 */
export const prizeCalculatorOpenQualifierS5 = (
  playersCount: number
): number[] => {
  if (!Number.isSafeInteger(playersCount) || playersCount <= 0) return [];

  const prizes = new Array<number>(playersCount).fill(0);
  prizes[0] = FIRST_PLACE_PRIZE_OPEN_QUALIFIER_S5;

  // Matches the finance sheet: second place always exists once there are two
  // players, and takes the whole pool while fewer than 4 players are paid
  // beyond the winner (no earlier winner-only cutoff).
  if (playersCount < 2) return prizes;

  const pool =
    INITIAL_PURSE_S5 -
    FIRST_PLACE_PRIZE_OPEN_QUALIFIER_S5 -
    SIDE_GAMES_OPEN_QUALIFIER_S5 +
    ENTRY_FEE_S5 * playersCount;
  const tierReserve =
    (PRIZE_TIERS_OPEN_QUALIFIER_S5.reduce(
      (sum, tier) => sum + tier.prize,
      0
    ) * playersCount) / 20;
  const curvePool = pool - tierReserve;
  const ratio = PRIZE_RATIO_OPEN_QUALIFIER_S5;

  let awarded = 0;
  // Position 1 is settled last. Position 2 is overall rank 3.
  for (let position = 2; position < playersCount; position++) {
    const tier = PRIZE_TIERS_OPEN_QUALIFIER_S5.find(
      ({ percentile }) => position <= playersCount * percentile
    );
    if (!tier) break;

    const prize = Math.round(
      (ratio - 1) * Math.pow(ratio, -position) * curvePool + tier.prize
    );
    prizes[position] = prize;
    awarded += prize;
  }

  prizes[1] = pool - awarded;
  return prizes;
};
